// extracted by mini-css-extract-plugin
export var iframe = "instructions-video-module--iframe--52fbc";
export var popup = "instructions-video-module--popup--6a25f";